<template>
  <div class="gm606-chart common-border">
    <div class="common-border2" :style="{ height: `${height}px` }">
      <el-row class="header">
        <el-col :span="24">
          <span class="sensor-name">{{ name }}:</span>
          <span class="value">{{ lastValue }}</span>
          <span class="unit-name">{{ unitName }}</span>
        </el-col>
      </el-row>
      <el-row class="center mt-15" type="flex" justify="center" align="middle">
        <el-col tag="span" :span="12">安装状态：{{ status.install }}</el-col>
        <el-col tag="span" :span="12">运行状态：{{ status.run }}</el-col>
      </el-row>
      <el-row class="center" type="flex" justify="center" align="middle">
        <el-col tag="span" :span="12">
          故障状态：
          <span :class="status.faultClass">{{ status.fault }}</span>
        </el-col>
        <el-col tag="span" :span="12">
          报警状态：
          <span :class="status.alarmClass">{{ status.alarm }}</span>
        </el-col>
      </el-row>
      <el-row class="center" v-if="gasTypeName" type="flex" align="middle">
        <el-col tag="span" :span="12">气体类型：{{ gasTypeName }}</el-col>
        <el-col tag="span" :span="12"></el-col>
      </el-row>

      <div class="chart-box">
        <v-chart
          ref="chartRef"
          :options="opt"
          :smoothTimeLine="true"
          :smoothTimeLineMax="maxLen"
          :autoresize="true"
        ></v-chart>
      </div>
    </div>
  </div>
</template>

<script>
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { graColor } from '@/views/realdata/FCBR-100/options';
import { tools } from '../utils';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    height: Number
  },
  inject: ['time'],
  data() {
    return {
      maxLen: 30,
      name: '',
      unit: '',
      unitName: '',
      lastValue: '',
      gasTypeName: '',
      status: {
        install: '',
        run: '',
        alarm: '',
        fault: ''
      },
      chart: [],
      opt: lineAreaStyle({
        color: '#009fe9',
        series: [
          {
            symbol: 'emptyCircle',
            areaStyle: { color: graColor('rgb(3, 153, 224)', 'rgba(3, 153, 224, 0.1)') }
          }
        ],
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#009fe9'
            }
          }
        },
        yAxis: {
          max: null,
          boundaryGap: [0, '20%']
        },
        grid: {
          top: 28,
          left: 30,
          right: 30,
          bottom: 20
        }
      })
    };
  },
  methods: {
    ...tools,
    modifyChart(data) {
      this.lastValue = data;
      if (this.chart.length >= this.maxLen) this.chart.shift();
      this.chart.push([this.time.begin, data]);
      this.opt.series[0].data = this.chart;
    },
    setState(n) {
      Object.assign(this, {
        name: n.name,
        unit: n.unit,
        unitName: n.unitName,
        gasTypeName: n.gasTypeName
      });

      Object.assign(this.status, {
        install: this.pumpInstallText(n.installState),
        run: this.pumpRunText(n.runstate),
        fault: this.pumpFaultText(n.faultState),
        faultClass: this.pumpFaultClass(n.faultState),
        alarm: this.pumpAlarmText(n.alarmState),
        alarmClass: this.pumpAlarmClass(n.alarmState)
      });
    },
    setData(n) {
      this.setState(n);
      this.modifyChart(n.value);
    },
    setDataList(list, data) {
      this.setState(data);

      this.chart.push(...list.map(e => [e.beginTime, e.value]));
      this.opt.series[0].data = this.chart;
    }
  },
  watch: {
    data: 'setData'
  }
};
</script>

<style lang="scss">
.gm606-chart {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 4px;
  .header {
    font-size: 18px;
    background: #013c5d;
    padding: 12px 10px;
    border-radius: 4px;
    font-weight: bold;

    .sensor-name,
    .value,
    .unit-name {
      margin-right: 5px;
    }

    .unit-name {
      font-size: 12px;
    }
  }
  .center {
    padding: 5px;
    font-size: 16px;
    .el-col {
      text-align: center;
    }
  }
  .chart-box {
    height: calc(100% - 140px);
  }
}
</style>
